module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "في-منزل-الأستاذ-صباح"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في منزلِ الأستاذ صباح")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قَفَز عليٌّ مِن فوقِ سور منزل \"حلمي الحلاق\" الَّذي يقع خلف منزل الأستاذ مباشرةً ومنه دخل إلى منزل الأستاذ بنفس الطَّريقة، وما كان يتوقّع حتّى في خياله أن يُلاقي الباشا في منزل الحمداني يومًا، ولكنَّ الوضع اختلف تلك اللَّيلة فالأمر يتعلَّق بحفيدهِ المفضَّل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قال عليّ مصدومًا لوجود الباشا جالسًا على درَجِ الباب الخارجيِّ للمنزِل:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- رفعت باشا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تقدَّم عليّ بضع خطواتٍ بطيئةٍ محاولًا دخول المنزل، لكنَّ الباشا منعه بأن رفع العصا وصوَّبها إلى صدره ووكزه بها وأرجعه إلى الخلف قائلًا:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنت السَّبب، نعم، أنت السَّبب في هذا البلاء، لو لم تسلبه أسباب الحياة لكان حفيدي هنا الآن بين عائلته.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا أفهم ما الَّذي فعلته لتكرهني هكذا وتتّهمني بـ...")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قاطعهُ الباشا بصوتٍ عالٍ: لا تتغابَ! أنا أعرف الحقدَ الَّذي تحمله في داخلك على عزّام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لن أردّ عليك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنت السَّبب في كلِّ ما يحصل له، ماذا تريد من حفيدي؟ ها، لِمَ لا تتركه وشأنه؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا أفهم ما تقول، لكن لو كان هدفك إبعادي عن عزّام فلن تُفلِح أبدًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تستأسد أمامي هكذا لأنّني سأسحقك، تظنُّ نفسك قادرًا على خِداعي كما خدعت حفيدي بصداقتك المزيّفة!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يكفي، أنا لست مُجبرًا على سماع تفاهاتِك، ولن أردّ عليك إكرامًا لعزّام والخالة مُنيرة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- منيرة! تحبّها كثيرًا، هذا واضح.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يردّ عليه، ودخل إلى البيت.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وقَف في الممرّ المؤدّي إلى الصّالة يسمع ما يدور بين منيرة وزوجها السّابق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لقد وعدتَني يا صباح، قلتَ لي لا تقلقي على أولادك وهُم معي، سأحميهم حتّى من أنفُسِهم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ الأستاذ صباح: حاولتُ أن أفهم، لماذا فعل ذلك؟ لم أجد تفسيرًا يا مُنيرة! فاجأني بتصرُّفِه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تدخّل عسّاف قائلًا: حدَث كلُّ هذا بسبب تلك الأفكار الَّتي تُسيطر على عُقولهم الفارغة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صباح: ذَوُو العقول الفارغة هم الَّذين يجتَمعون كلَّ ليلةٍ على طاولة سعدي للعب القِمار.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكت عسّاف وردّت عليه مُنيرة:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لكن ما الفائدة؟ نحن لم نَجنِ من كلِّ هذا سوى القلقِ والحُزن عليهم، ما الفائدة الَّتي سيجنونَها سوى ضياع مستقبلهم وإغراق البلد في الفوضى؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صباح: لا فائدة من الكلام معكُما! لن تفهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("منيرة: لا أريد أن أفهم شيئًا، أريد ابني فقط، أعلم بأنَّك لن تستطيع فعل شيءٍ، لكن أبي يستطيع وسيخرجه من السِّجن، ولن أترك لك أبنائي هذه المرّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صباح: هم أبنائي أيضًا، ولن أسمح لأحدٍ بالتدخُّل في شؤون عائلتي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("منيرة: وأنا لن أنتظر إذنًا منك لأنقذ ابني.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قبل أن تخرج نظرَت إلى عليّ وقالت له: ماذا تُريدون أن تفعلوا بنا؟ ماذا تريدون؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ظلّ عليّ واقفًا مكانه دون أن يردّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد أن هدأت قالت: اذهب إليه فهو يحتاجك الآن.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: خالة منيرة...")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قاطعَت كلامه: لا داعي أن تقولَ شيئًا، سأخرِجه من السّجن مهما كلّف الأمر، وسأبعده عن هذا الطّريق إلى الأبد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انصرفَتْ مُتّجهةً إلى السيّارة الَّتي جلس فيها الباشا مُسبقًا، فتح السّائق لها الباب جلسَت إلى جانب والِدها، وتحرَّكت السيّارة إلى أن اختفت عن ناظريه تمامًا. التفتَ عليّ نحو الأستاذ صباح وبخطواتٍ بطيئةٍ مشى لكن \"خيري\" استوقفه:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- حطَّموا كلَّ شيءٍ، بعثَروا محتويات غرفة المكتبِ، حتّى المطبخ لم يسلم من عبثِهم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ظلّ عليٌّ ساكتًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتبه له الأستاذ صباح وقالَ:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سمعتُ صوتك ولم أصدّق، ماذا تفعل هنا يا علي؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ عليٌّ: هل أنت بخير؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صمتَ الأستاذ قليلًا ثمَّ قال: كنت أتوقَّع هذا الشّيء يا عليُّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لماذا لمَ يهرب؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- صدّقني، لا أعرف، أنا مندهشٌ مثلك تمامًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صمتَ عليّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لكن أنتَ، ما الَّذي تفعله هنا؟ ألم يخبرك عسّاف؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لم أستطع المغادرة قبل رؤيتك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("زفَر الأستاذ بيأسٍ: آهٍ يا علي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أردتُ أن أطمئنَّ عليكَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تَخفْ، أنا بخيرٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وعزّام!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ولدي ليس أفضل من بقيّة الشّباب الَّذين اعتُقِلوا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكَت لحظةً وزفر بقوَّةٍ:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ذلك العجوز الخَرِف لا يتركني أُربّي أبنائي، يتدخّل في كلِّ شيءٍ، سئمت تدخُّله في حياة أبنائي، هدفه الوحيد أن يُشعِرني بالعجزِ وأنّني لا أستطيعُ حمايَتهم؛ لم ينجح باستمالة عزّام ناحيته، لكنَّه نجح بإفساد أخلاقِ عسّاف بعد أن فتح له خزائن ثروتهِ، لكن لا، لا! لن أسمح له بتدمير حياة أولادي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لكنَّه هو..")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظر الأستاذ في عيني عليّ وقال مُقاطعًا صمته:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- نعم هو الوحيد القادر على إنقاذ عزّام، هذا ما أردتَ قوله، عزّام ولَدي لن يقبل مساعدتهُ ولا يرضى بتدخُّلاته المستمرَّة في حياته.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4733f546","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch013.vue
// module id = 96
// module chunks = 0